import { render } from "./BarMenuItem.vue?vue&type=template&id=3bea5e82"
import script from "./BarMenuItem.vue?vue&type=script&lang=js"
export * from "./BarMenuItem.vue?vue&type=script&lang=js"

import exportComponent from "/Users/romain/Developer/vue-document-editor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__